export default __webpack_public_path__ + "static/media/MaryanaRo.254b556b.png";